import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=79f3baba"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomer.vue?vue&type=style&index=0&id=79f3baba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports